import { Styles } from "types";

export const styles: Styles = {
    grid: {
        gridTemplateColumns: "repeat(auto-fill, minmax(269px, 1fr))",
    },
};
